import React from 'react';
import { Nav, NavItem, NavLink } from 'reactstrap';
import { FaSignOutAlt } from "react-icons/fa";
import { useNavigate } from 'react-router-dom';
import './Sidebar.css';

const Sidebar = ({ toggleTab, activeTab }) => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('token'); // Hapus token
    navigate('/admin/login'); // Arahkan ke halaman login
  };

  return (
    <div className="sidebar">
      <div style={{ padding: '20px' }}>
        <img src="/CENDEKIA-LOGO.png" alt="Corporate Logo" style={{ maxWidth: '100%', paddingBottom: '0px' }} />
      </div>
      <hr 
        style={{
          margin:'0px',
          paddingBottom:'10px',
        }}
      />
      <Nav vertical className="nav">
        <NavItem>
          <NavLink onClick={() => toggleTab('welcome')} active={activeTab === 'welcome'}>
            Dashboard
          </NavLink>
          <NavLink onClick={() => toggleTab('data')} active={activeTab === 'data'}>
            Data Pendaftaran
          </NavLink>
          {/* {Array.from({ length: 13 }, (_, i) => (
            <NavLink key={i} onClick={() => toggleTab(`menu${i + 1}`)} active={activeTab === `menu${i + 1}`}>
              Menu {i + 1}
            </NavLink>
          ))} */}
        </NavItem>
      </Nav>

      <hr 
        style={{
          margin:'0px',
          paddingBottom:'10px',
        }}
      />
      {/* Tombol Log Out */}
      <div className="sidebar-footer">
        <button className="logout-btn" onClick={handleLogout}>
          <FaSignOutAlt className="logout-icon" /> Log Out
        </button>
      </div>

    </div>
  );
};

export default Sidebar;
